import React, { Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router';

import { LogoLoading } from "../../components/Loading";
import Sidebar from '../../components/Sidebar';
import { B2B_REQUEST_URL,ADD_NEWS_URL, ADD_SALE, ATTRIBUTES_LISTING_URL, CATEGORIES_URL, COMPANY_LISTING_URL, COUPON_CODE_LISTING, DEFUALT_URL, EXCHANGE_ORDER, HOME_PAGE_PRODUCT_LISTING, ORDER_DETAILS, ORDER_LISTING_URL, NEWS_DETAIL_URL, NEWS_LISTING_URL, PROFILE_URL, PRO_CLUB_LEVEL_LISTING_URL, PRO_CLUB_USERS_LISTING_URL, RETURNED_ORDERS, SALES_LISTING_URL, TAX_CLASS_URL, UPDATE_NEWS_URL, UPDATE_SALE_URL, USER_DETAILS_URL, USER_LISTING_URL, CAREERS_LISTING_LINK, CAREERS_ADD_LINK, CAREERS_UPDATE_LINK, CANDIDATE_LISTING_LINK, EVENT_LISTING_LINK, EVENT_ADD_LINK, EVENT_UPDATE_LINK, ADD_PRESS_RELEASE_URL, UPDATE_PRESS_RELEASE_URL, PRESS_RELEASE_LISTING_URL, MEDIA_WALL_LINK, CONTACT_US_LINK, INDUSTRIAL_ACCELERATOR_LISTING_LINK, PRODUCTS_LEADS_LISTING_LINK, DEPARTMENT_LISTING_LINK, BROCHURES_LISTING_URL, SPOTLIGHT_URL, ADD_SPOTLIGHT_URL, SPOTLIGHT_LISTING_URL, SPONTANEOUS_CANDIDATE_LISTING_LINK, ANALYTICS_URL } from '../../constants';
import DashboardApplicants from '../../pages/ApplicantsDashboard';


// import Header from '../../components/Header';

// page imports
const Profile = React.lazy(() => import('../../pages/Profile'));
const AddProduct = React.lazy(() => import('../../pages/AddProduct'));
const Products = React.lazy(() => import('../../pages/ProductListing'));
const Users=React.lazy(()=>import('../../pages/Users'))
const Careers=React.lazy(()=>import('../../pages/Careers'))
const AddCareer=React.lazy(()=>import('../../pages/Careers/AddCareer'))
const Candidate=React.lazy(()=>import('../../pages/Candidate'))
const EventListing=React.lazy(()=>import('../../pages/Events/EventListing'))
const AddEvent=React.lazy(()=>import('../../pages/Events/AddEvent'))
const EditEvent=React.lazy(()=>import('../../pages/Events/EditEvent'))
const PressListing=React.lazy(()=>import('../../pages/PressRelease/PressListing'))
const AddPressRelease=React.lazy(()=>import('../../pages/PressRelease/AddPressRelease'))
const MediaWall=React.lazy(()=>import('../../pages/MediaWall'))
const ContactUsListing=React.lazy(()=>import('../../pages/ContactUs/Listing'))
const IndustrialAcceleratorListing=React.lazy(()=>import('../../pages/IndustrialAccelerator/Listing'))
const LeadsFromProducts=React.lazy(()=>import('../../pages/LeadsFromProducts/Listing'))
const BrochureListing=React.lazy(()=>import('../../pages/Brochures/Listing'))
const DepartmentsListing=React.lazy(()=>import('../../pages/Departments/Listing'))
const SpotlightListing=React.lazy(()=>import('../../pages/Spotlight/Listing'))
const AddSpotlight=React.lazy(()=>import('../../pages/Spotlight/AddSpotlight'))
const SpontaneousCandidateContainer=React.lazy(()=>import('../../pages/SpontaneousApplications'))
// const EditSpotlight=React.lazy(()=>import('../../pages/Spotlight/EditSpotlight'))

// page imports


function AdminRoutes(props) {
  return (
    <>
      <Sidebar />
        <Suspense fallback={<LogoLoading />}>
          <Routes>
            <Route path={ANALYTICS_URL} element={<DashboardApplicants/>}/>
            <Route path={DEFUALT_URL} element={<Products/>}/>
            <Route path={PROFILE_URL} element={<Profile />} />

            <Route path={ADD_NEWS_URL} element={<AddProduct />} />
            <Route path={UPDATE_NEWS_URL+'/:id'} element={<AddProduct isUpdate={true}  />} />
            <Route path={NEWS_LISTING_URL} element={<Products/>}/>

            <Route path={ADD_PRESS_RELEASE_URL} element={<AddPressRelease />} />
            <Route path={UPDATE_PRESS_RELEASE_URL+'/:id'} element={<AddPressRelease isUpdate={true}  />} />
            <Route path={PRESS_RELEASE_LISTING_URL} element={<PressListing/>}/>

            {/* <Route path={NEWS_DETAIL_URL+'/:id'} element={<ProductDetails/>}/> */}
            {/* <Route path={USER_LISTING_URL} element={<Users/>}/> */}
            <Route path={CAREERS_LISTING_LINK} element={<Careers/>}/>
            {/* <Route path={CAREERS_ADD_LINK} element={<AddCareer/>}/> */}
            {/* <Route path={CAREERS_UPDATE_LINK+'/:id'} element={<AddCareer isUpdate={true}/>}/> */}

            <Route path={CANDIDATE_LISTING_LINK} element={<Candidate/>}/>
            <Route path={SPONTANEOUS_CANDIDATE_LISTING_LINK} element={<SpontaneousCandidateContainer/>}/>
            <Route path={EVENT_LISTING_LINK} element={<EventListing/>}/>
            <Route path={EVENT_ADD_LINK} element={<AddEvent/>}/>
            <Route path={EVENT_UPDATE_LINK+'/:id'} element={<EditEvent/>}/>


            <Route path={CONTACT_US_LINK} element={<ContactUsListing/>}/>
            {/* <Route path={INDUSTRIAL_ACCELERATOR_LISTING_LINK} element={<IndustrialAcceleratorListing/>}/> */}
            <Route path={PRODUCTS_LEADS_LISTING_LINK} element={<LeadsFromProducts/>}/>
            <Route path={BROCHURES_LISTING_URL} element={<BrochureListing/>}/>


            <Route path={DEPARTMENT_LISTING_LINK} element={<DepartmentsListing/>}/>
            <Route path={SPOTLIGHT_LISTING_URL} element={<SpotlightListing/>}/>
            <Route path={ADD_SPOTLIGHT_URL} element={<AddSpotlight/>}/>



            <Route path={MEDIA_WALL_LINK} element={<MediaWall/>}/>
            <Route path='*' element={<Navigate to={DEFUALT_URL} />} />
          </Routes>
        </Suspense>
    </>
  )
}

export default AdminRoutes
